module.exports = __webpack_public_path__ + "img/payment-visa.25d62d92.svg";